export default __webpack_public_path__ + "static/media/linkedin.8f51fe43.svg";